module.exports = __webpack_public_path__ + "img/spirit_bg.7da03863.png";